import { SETTINGS_COMPANY_PROFILE_ACTION, CARD_INFORMATIONS } from '../actions/settings_companyProfile.action';

const initialState = {
    company_name: "",
    company_zip: "",
    company_address: "",
    company_city: "",
    company_state: "",
    company_billing_id: "",
    company_billing_tax_id: "",
    company_billing_npi: "",
    company_billing_address: "",
    company_billing_city: "",
    company_billing_zip: "",
    company_billing_state: "",
    company_contact_phone: "",
    company_contact_email: "",
    company_contact_website: "",
    company_payers: [],
    company_brokers: [],
    dispatch_info: ""
};

export function companyProfile(state = initialState, action) {
    switch (action.type) {
        case SETTINGS_COMPANY_PROFILE_ACTION:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
}

export function billingInformations(state = {}, action) {
    switch (action.type) {
        case CARD_INFORMATIONS:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/app/reducers/allReducers.js